import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_lp_button, {
      outline: "",
      iconLeft: "ics_download-template",
      textColor: "red-lp-100",
      color: "red-lp-100",
      title: "Download template file",
      onClick: _ctx.handleDownloadTemplate,
      fontBold: ""
    }, null, 8, ["onClick"])
  ]))
}